export default __webpack_public_path__ + "static/media/demonologistaction.6b296ce4.png";